export const LOAD_DECISION_SUMMARY_STARTED = "LOAD_DECISION_SUMMARY_STARTED";
export const LOAD_DECISION_SUMMARY_SUCCESS = "LOAD_DECISION_SUMMARY_SUCCESS";
export const LOAD_CONTRACT_GEN_PERMISSIONS_STARTED = "LOAD_CONTRACT_GEN_PERMISSIONS_STARTED";
export const LOAD_CONTRACT_GEN_PERMISSIONS_SUCCESS = "LOAD_CONTRACT_GEN_PERMISSIONS_SUCCESS";
export const CONTRACT_GENERATION_STARTED = "CONTRACT_GENERATION_STARTED";
export const CONTRACT_GENERATION_SUCCEEDED = "CONTRACT_GENERATION_SUCCEEDED";
